module.exports = __webpack_public_path__ + "static/media/UserTie.688f388a.svg";